export default "__VITE_ASSET__BvD8W6Zu__"